import Vue from "vue";
import BookingEngine from "@liveflight/components/blocks/booking-engine/booking-engine.vue";
import BtnBack from "@liveflight/components/atoms/btn-back.vue";
import Chevron from "@/components/blocks/chevron.vue";
import SentryInit from "@src/sentry";

// site specific components and settings
export default function site_config() {
  Vue.component("booking-engine", BookingEngine);
  Vue.component("chevron", Chevron);
  Vue.component("button-back", BtnBack);
  SentryInit();
}
